import {paApp} from '../paApp';
import {paRoute} from './paRoute';
import {paDom} from './paDom';
import {paIframeChild} from './paIframeChild'
import {paDomNodeList} from "./paDomNodeList";
import {paDomEl} from "./paDomEl";
import {paData} from "./paData";

export const paCore = {
    libDomHandler: null,
    data: null,
    route: {params: null, hash: null},
    init() {
        paData.init();
        paDomEl.init();
        paDomNodeList.init();
        paRoute.init();
        paIframeChild.init();
        paApp.initCritical();

        paDom.onLoad(function () {
            paDom.init();
            paApp.init();
        });
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/paCore.js